import { defineMessages } from 'react-intl'

export default defineMessages({
  send: { defaultMessage: 'Send' },
  edit: { defaultMessage: 'Revise' },
  remove: { defaultMessage: 'Delete' },
})
